import { Grid, Typography } from '@mui/material';
import searchEmpty from '../assets/images/searchEmpty.svg';

const TempSearch = () => {
  return (
    <>
      <Grid container direction='column' justifyContent='center' alignItems='center'>
        <Grid item xs={12}>
          <img src={searchEmpty} alt='Search anything' width='100px' height='auto' />
        </Grid>
        <Grid item xs={12} mt={6}>
          <Typography variant='h6' className='normal-font'>
            Search for any products (e.g. top hotel in cox's bazar)
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default TempSearch;
